import React from 'react';
import intl from "react-intl-universal";

import {ViewType} from "../../../../stores/WorkspaceStore";

import './EmptyListView.css';

export interface EmptyListViewProps {
    view: ViewType;
}

export const EmptyListView = ({view}: EmptyListViewProps) => {
    let {title, message} = getMessageByView(view);
    return (
        <div className="EmptyListView">
            {title ? <span className="EmptyListTitle">{title}</span> : null}
            <div className="EmptyListMessage">
                {message}
            </div>
        </div>
    )
}


const getMessageByView = (view: ViewType) => {
    switch (view) {
        case "active":
            return {
                title: intl.get('empty-list.active.title').d('No active pages'),
                message: intl.get('empty-list.active.message').d('Pages viewed by others appear here in real-time'),
            };
        case "recent":
            return {
                title: intl.get('empty-list.recent.title').d('No recently opened pages'),
                message: intl.get('empty-list.recent.message').d('Here will be a list of pages recently visited by you on this device.'),
            };
        case "archive":
            return {
                title: intl.get('empty-list.archive.title').d('No archived pages'),
                message: intl.get('empty-list.archive.message').d('Anything you archive is moved here'),
            };
        case "trash":
            return {
                title: intl.get('empty-list.trash.title').d('Trash is empty'),
                message: intl.get('empty-list.trash.message').d('Anything you delete is moved here'),
            };
        case 'main':
            return {
                title: null,
                message: intl.get('empty-list.main.message').d('Here will be a list of pages and clusters when you create them.'),
            };
    }
}